module.exports = __webpack_public_path__ + "static/img/image16.562088c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image16.jpg
// module id = N6YJ
// module chunks = 1